import gradientBg from "../../assets/AuthGradientBg.svg"
import AuthBg from "../../assets/HandsVector.svg"
import Microphone from "../../assets/MicrophoneVector.svg"
import { motion } from "framer-motion";
const AuthContainer = () => {
  return (
    <motion.div initial={{ x: 60, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1 }}
      className="h-auto rounded-[33px] w-full basis-[55%] bg-[#F15836] relative overflow-hidden lg:block hidden">
      <img src={AuthBg} alt="AAAbg" className=" absolute bottom-0 right-0 w-full z-50" />
      <img src={Microphone} alt="AAAbg" className=" absolute top-3/4 -translate-x-1/2 left-1/2 -translate-y-3/4" />
      <img src={gradientBg} alt="gradientbg" className="absolute w-full z-50" />
      <div className="p-10 relative z-50">
        <h1 className="max-w-[483px] text-[64px] font-semibold text-transparent bg-clip-text bg-textGradient leading-[1.1] mb-4">The best place to develop your skills</h1>
        <p className="text-xl text-transparent bg-clip-text bg-textGradient">Sign in to elevate and gain more</p>
      </div>
    </motion.div>
  )
}

export default AuthContainer